import api from './api';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export async function translateText(text, sourceLang, targetLang) {
  if (!text || !sourceLang || !targetLang || text.trim() === '') {
    return text;
  }

  try {
    
    const response = await api.post(`${API_URL}/api/translate`, {
       q: text,         // <-- ici on renomme text en q
  from: sourceLang,
  to: targetLang,
  format: 'text'
    });

    
    return response.data.translatedText;
  } catch (error) {
    console.error('Erreur de traduction :', error.message);
    return text;
  }
}
export async function translateStrict(text, sourceLang, target) {
  const { data } = await api.post(`${API_URL}/api/translate`, {
    q: text,
    from: sourceLang || 'auto',
    to: target,
  });
  return data.translatedText;          
}
